<template>
    <div class="roothome_m">

        <div class="wrapper" style="background-color: white;">
            <!-- ################    Top Menu Bar    ################# -->
            <div align="center" class="head0">
                <div align="center" class="head0_2m">
                    <div class="head1m">
                        <img src="/static/imgs/ic_back_w.png" alt="menu" class="im_menu2" @click="goToBack()" onMouseOver="this.style.cursor='pointer'">
                    </div>
                    <div class="head2m">
                        <span class="tx_logol" style="font-size: var(--font-size-title-mobile_small);">{{ getInterText(inter_ind.expedicao) }}</span>
                    </div>
                <div  class="head3m">

                    <div v-if="!user.sucess" class="di_profile" @click="setShowLogin(true)">
                        <img src="/static/imgs/ic_profile2.png" alt="profile" class="im_profile_m2">
                    </div>

                    <div v-else class="di_profile" @click="showPopEscritorio()">
                        <div v-if='user.foto === ""' class="im_profile_m2" style="justify-content: center; align-items: center; background-color: var(--bg-blue)">
                            <span class="tx_initials" >{{ getInitials(user) }}</span>
                        </div>
                        <img id="botao_profile2" v-else-if='hasHttp(user.foto)'  :src='user.foto' alt="profile" class="im_profile_m2">
                        <img id="botao_profile3" v-else :src='baseUrlImg + "PROFILE/" + user.foto'     alt="profile" class="im_profile_m2">
                    </div>
                    <div v-if="showPopupEscritorio" class="di_popescritorio" id="popup_escritorio">
                        <div class="arrow_top"></div>
                        <span class="tx_login_b" >{{ getFirstAndLastWords(user.nome) }}</span>
                        <span class="tx_login" onMouseOver="this.style.cursor='pointer'" @click.prevent.stop="goToMinhaPagina()">{{ getInterText(inter_ind.minha_conta) }}</span>
                        <span class="tx_login" onMouseOver="this.style.cursor='pointer'" @click="goToPagina('mEditUser')">{{ getInterText(inter_ind.configuracoes) }}</span>
                        <span class="tx_login" onMouseOver="this.style.cursor='pointer'" @click="logout()">{{ getInterText(inter_ind.sair) }}</span>
                    </div>
                </div>
                </div>
            </div>

            <!--Barra de cabecalho com imagem-->
            <img src="/static/imgs/bg_exp_head_2.jpg" style="width: 100%; height: auto; object-fit: cover; margin-top: var(--top-bar-heigth); object-position: top;"/>


            <div class="div_expedicao">
                <div style="display: flex; flex-direction: row-reverse;">
                    <span>
                        {{ getInterText(inter_ind.expedicao_p1) }}
                    </span>
                    <img src="/static/imgs/expedicao_trans_blue.png" style="height: 12vh; object-fit: contain; margin-right: 5%;"/>
                </div>
                <span style="margin-top: 2vh; margin-bottom: 2vh;">
                    {{ getInterText(inter_ind.expedicao_p2) }}
                </span>
                <span style="margin-bottom: 2vh;">
                    {{ getInterText(inter_ind.expedicao_p3) }}
                </span>
                <span style="margin-bottom: 2vh;">
                    {{ getInterText(inter_ind.expedicao_p4) }}
                </span>
                <span style="margin-bottom: 2vh;">
                    {{ getInterText(inter_ind.expedicao_p5) }}
                </span>

                <span class="tx_border1">ACTION</span>
                <span class="tx_border2">ACTION</span>
            </div>

            <div style="display: flex; flex-direction: row; overflow-x: scroll; margin-bottom: 2vh">
                <div v-for="(album, j) in albuns" style="display: flex; flex-direction: row;" :key="j">
                    <div v-for="(foto, i) in album.fotos" @click="showGalery(true, j, i)" :key="i">
                        <img :src="foto.file" style="width: 45vw; max-height: 35vw; object-fit: contain; margin-right: 0vw;" />
                    </div>
                </div>
            </div>

            <div style="height: 3vh;"/>
        </div>


        <!--Janela Login-->
        <div class="div_login_m" v-if="showLogin" >
            <div class="parts_m">
                <div style="display: flex; justify-content: flex-end; width: 100%;" @click="setShowLogin(false)">
                    <img src="/static/imgs/bt_fechar_w.png" class="im_close_w" onMouseOver="this.style.cursor='pointer'">
                </div>

                <div style="text-align: center; margin-top: 5vh;">
                    <img src="/static/imgs/advicep_horizontal_w.png" alt="menu" style="height: 8vh">
                </div>

                <!--<div class="div_face_w" style="margin-top: 10vh;">-->
                    <!--<div class="div_faceim">-->
                        <!--<img src="/static/imgs/ic_face_blue.png" alt="facebook" class="im_face">-->
                    <!--</div>-->

                    <!--<div class="div_facetx">-->
                        <!--<span class="tx_face_m"> {{ getInterText(inter_ind.entre_face) }} </span>-->
                    <!--</div>-->
                <!--</div>-->


                <div v-if="!isiOS()" class="div_face_w" style="margin-top: 8vh; margin-bottom: 5vh" @click="externalLoginGoogle_startApp()">
                <!--<div class="div_face_w" style="margin-top: 1vh; margin-bottom: 5vh">-->
                    <div class="div_faceim">
                        <img src="/static/imgs/ic_google.png" alt="facebook" class="im_face">
                    </div>

                    <div class="div_facetx">
                        <span class="tx_face_m unselectable"> {{ getInterText(inter_ind.entre_google) }} </span>
                    </div>
                </div>
                <div v-else style="height: 12vh;"/>




                <div class="div_nome_l">
                    <span class="tx_nome_before_w" @click="clickInput(1, true)" v-if="!editing[1].status" onMouseOver="this.style.cursor='pointer'" tabindex="2">E-mail</span>
                    <div class="hr_w" @click="clickInput(1, true)" onMouseOver="this.style.cursor='pointer'" v-if="!editing[1].status"/>
                    <span class="tx_nome_w" @click="clickInput(1, false)" v-if="editing[1].status">E-mail</span>
                    <input id="emailid" class="input_name_w" type="text" v-model="editing[1].texto" v-if="editing[1].status" tabindex="3"/>
                    <span v-if="!checkEmail(editing[1].texto) && editing[1].texto.length>5" class="error_msg">{{ getInterText(inter_ind.email_invalido) }}</span>
                </div>

                <div class="div_nome_l">
                    <span class="tx_nome_before_w" @click="clickInput(0, true)" v-if="!editing[0].status" onMouseOver="this.style.cursor='pointer'"> {{ getInterText(inter_ind.senha) }} </span>
                    <div class="hr_w" @click="clickInput(0, true)" onMouseOver="this.style.cursor='pointer'" v-if="!editing[0].status"/>
                    <span class="tx_nome_w" @click="clickInput(0, false)" v-if="editing[0].status"> {{ getInterText(inter_ind.senha) }} </span>
                    <input id="nameid" class="input_name_w" type="password" v-model="editing[0].texto" v-if="editing[0].status" tabindex="4"/>
                    <span v-if="!checkPass(editing[0].texto) && editing[0].texto!=''" class="error_msg">{{ getInterText(inter_ind.senha_errada) }}</span>
                </div>

                <div class="div_check" style="margin-top: 4vh;">
                    <div class="div_check_in" @click="changeCheckState(0)">
                        <span v-if="valid.enterAuto" class="tx_checkbox">&#10003;</span>
                    </div>
                    <span class="tx_check" style="flex-grow: 1; text-align: left;">{{ getInterText(inter_ind.entrar_auto) }}</span>
                    <span class="tx_check" style="cursor: pointer;">{{ getInterText(inter_ind.esqueceu_senha) }}</span>
                </div>

                <span v-if="senhaErrada" class="error_msg">{{ getInterText(inter_ind.senha_errada_2) }}</span>

                <img v-if="loading.user" src="/static/imgs/loading5.gif" alt="Carregando" class="im_loading_up">

                <div style="display: flex; flex-direction: row; margin-top: 10vh">
                    <div class="div_botao_login" style="margin-right: 2vw; background-color: white;" @click="tryLogin()" onMouseOver="this.style.cursor='pointer'" tabindex="4">
                        <span class="tx_continuar unselectable" style="color: var(--bg-blue);"> {{ getInterText(inter_ind.entrar) }} </span>
                    </div>
                    <router-link :to="{ params: { stabs: estabs_full, categs: cats_full, idCat: idCat}, name: 'mRegisterUser'}">
                        <div class="div_botao_login">
                            <span class="tx_continuar_w unselectable" > {{ getInterText(inter_ind.cadastre) }} </span>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>

        <!--Galeria de fotos overlay-->
        <div class="overgalery" >
            <div class="div_galery">
                <div class="div_fechar_over" @click="showGalery(false)">
                    <img src="/static/imgs/bt_fechar_2.png" class="im_close_m_photo">
                </div>
                <Slider :banners="albunsFull" baseUrlImg="" :fotoIndex="fotoIndex"/>
            </div>
        </div>
    </div>
</template>

<script>
    import { advMixin } from '../scripts/advMixin'
    import Slider from '@/components/templates/Slider.vue'

    export default {
        mixins: [advMixin],
        name: 'mExpedicaoAdvice',
        data () {
            return {
                name: 'mExpedicaoAdvice',
                fotoIndex: 0,
                albunsFull: [],
                albuns: [
                    {
                        id: 0,
                        legenda: "01Barra de Camaratuba",
                        indFoto: 0,
                        fotos: [
                            {
                                file: "static/imgs/exp/albuns/01Barra de Camaratuba/55.jpg",
                                legenda: "01Barra de Camaratuba FOTO 1"
                            },
                            {
                                file: "static/imgs/exp/albuns/01Barra de Camaratuba/56.jpg",
                                legenda: "01Barra de Camaratuba FOTO 2"
                            },
                            {
                                file: "static/imgs/exp/albuns/01Barra de Camaratuba/57.jpg",
                                legenda: "01Barra de Camaratuba FOTO 3"
                            },
                            {
                                file: "static/imgs/exp/albuns/01Barra de Camaratuba/58.jpg",
                                legenda: "01Barra de Camaratuba FOTO 4"
                            },
                            {
                                file: "static/imgs/exp/albuns/01Barra de Camaratuba/60.jpg",
                                legenda: "01Barra de Camaratuba FOTO 5"
                            },
                            {
                                file: "static/imgs/exp/albuns/01Barra de Camaratuba/61.jpg",
                                legenda: "01Barra de Camaratuba FOTO 6"
                            },
                            {
                                file: "static/imgs/exp/albuns/01Barra de Camaratuba/62.jpg",
                                legenda: "01Barra de Camaratuba FOTO 7"
                            },
                            {
                                file: "static/imgs/exp/albuns/01Barra de Camaratuba/63.jpg",
                                legenda: "01Barra de Camaratuba FOTO 8"
                            },
                            {
                                file: "static/imgs/exp/albuns/01Barra de Camaratuba/65.jpg",
                                legenda: "01Barra de Camaratuba FOTO 9"
                            },
                            {
                                file: "static/imgs/exp/albuns/01Barra de Camaratuba/67.jpg",
                                legenda: "01Barra de Camaratuba FOTO 10"
                            },
                        ]
                    },
                    {
                        id: 1,
                        legenda: "02Lucena",
                        indFoto: 0,
                        fotos: [
                            {
                                file: "static/imgs/exp/albuns/02Lucena/39.jpg",
                                legenda: "02Lucena FOTO 1"
                            },
                            {
                                file: "static/imgs/exp/albuns/02Lucena/42.jpg",
                                legenda: "02Lucena FOTO 2"
                            },
                            {
                                file: "static/imgs/exp/albuns/02Lucena/43.jpg",
                                legenda: "02Lucena FOTO 3"
                            },
                            {
                                file: "static/imgs/exp/albuns/02Lucena/44.jpg",
                                legenda: "02Lucena FOTO 4"
                            },
                            {
                                file: "static/imgs/exp/albuns/02Lucena/45.jpg",
                                legenda: "02Lucena FOTO 5"
                            },
                            {
                                file: "static/imgs/exp/albuns/02Lucena/46.jpg",
                                legenda: "02Lucena FOTO 6"
                            },
                            {
                                file: "static/imgs/exp/albuns/02Lucena/49.jpg",
                                legenda: "02Lucena FOTO 7"
                            },
                            {
                                file: "static/imgs/exp/albuns/02Lucena/51.jpg",
                                legenda: "02Lucena FOTO 8"
                            },
                            {
                                file: "static/imgs/exp/albuns/02Lucena/53.jpg",
                                legenda: "02Lucena FOTO 9"
                            },
                            {
                                file: "static/imgs/exp/albuns/02Lucena/54.jpg",
                                legenda: "02Lucena FOTO 10"
                            },
                        ]
                    },
                    {
                        id: 2,
                        legenda: "03Jacaré",
                        indFoto: 0,
                        fotos: [
                            {
                                file: "static/imgs/exp/albuns/03Jacaré/2.jpg.jpg",
                                legenda: "03Jacaré FOTO 1"
                            },
                            {
                                file: "static/imgs/exp/albuns/03Jacaré/3.jpg.jpg",
                                legenda: "03Jacaré FOTO 2"
                            },
                            {
                                file: "static/imgs/exp/albuns/03Jacaré/4.jpg.jpg",
                                legenda: "03Jacaré FOTO 3"
                            },
                            {
                                file: "static/imgs/exp/albuns/03Jacaré/5.jpg.jpg",
                                legenda: "03Jacaré FOTO 4"
                            },
                        ]
                    },
                    {
                        id: 3,
                        legenda: "Araruna",
                        indFoto: 0,
                        fotos: [
                            {
                                file: "static/imgs/exp/albuns/Araruna/29.jpg",
                                legenda: "Araruna FOTO 1"
                            },
                            {
                                file: "static/imgs/exp/albuns/Araruna/30.jpg",
                                legenda: "Araruna FOTO 2"
                            },
                            {
                                file: "static/imgs/exp/albuns/Araruna/31.jpg",
                                legenda: "Araruna FOTO 3"
                            },
                            {
                                file: "static/imgs/exp/albuns/Araruna/32.jpg",
                                legenda: "Araruna FOTO 4"
                            },
                            {
                                file: "static/imgs/exp/albuns/Araruna/33.jpg",
                                legenda: "Araruna FOTO 5"
                            },
                        ]
                    },
                    {
                        id: 4,
                        legenda: "Areia",
                        indFoto: 0,
                        fotos: [
                            {
                                file: "static/imgs/exp/albuns/Areia/18.jpg",
                                legenda: "Areia FOTO 1"
                            },
                            {
                                file: "static/imgs/exp/albuns/Areia/19.jpg",
                                legenda: "Areia FOTO 2"
                            },
                            {
                                file: "static/imgs/exp/albuns/Areia/20.jpg",
                                legenda: "Areia FOTO 3"
                            },
                            {
                                file: "static/imgs/exp/albuns/Areia/34.jpg",
                                legenda: "Areia FOTO 4"
                            },
                            {
                                file: "static/imgs/exp/albuns/Areia/35.jpg",
                                legenda: "Areia FOTO 5"
                            },
                        ]
                    },
                    {
                        id: 5,
                        legenda: "Bananeiras",
                        indFoto: 0,
                        fotos: [
                            {
                                file: "static/imgs/exp/albuns/Bananeiras/21.jpg",
                                legenda: "Bananeiras FOTO 1"
                            },
                            {
                                file: "static/imgs/exp/albuns/Bananeiras/22.jpg",
                                legenda: "Bananeiras FOTO 2"
                            },
                            {
                                file: "static/imgs/exp/albuns/Bananeiras/23.jpg",
                                legenda: "Bananeiras FOTO 3"
                            },
                            {
                                file: "static/imgs/exp/albuns/Bananeiras/25.jpg",
                                legenda: "Bananeiras FOTO 4"
                            },
                            {
                                file: "static/imgs/exp/albuns/Bananeiras/26.jpg",
                                legenda: "Bananeiras FOTO 5"
                            },
                            {
                                file: "static/imgs/exp/albuns/Bananeiras/27.jpg",
                                legenda: "Bananeiras FOTO 6"
                            },
                            {
                                file: "static/imgs/exp/albuns/Bananeiras/28.jpg",
                                legenda: "Bananeiras FOTO 7"
                            },
                        ]
                    },
                    {
                        id: 6,
                        legenda: "Cabaceiras",
                        indFoto: 0,
                        fotos: [
                            {
                                file: "static/imgs/exp/albuns/Cabaceiras/10.jpg",
                                legenda: "Cabaceiras FOTO 1"
                            },
                            {
                                file: "static/imgs/exp/albuns/Cabaceiras/11.jpg",
                                legenda: "Cabaceiras FOTO 2"
                            },
                            {
                                file: "static/imgs/exp/albuns/Cabaceiras/12.jpg",
                                legenda: "Cabaceiras FOTO 3"
                            },
                            {
                                file: "static/imgs/exp/albuns/Cabaceiras/13.jpg",
                                legenda: "Cabaceiras FOTO 4"
                            },
                            {
                                file: "static/imgs/exp/albuns/Cabaceiras/14.jpg",
                                legenda: "Cabaceiras FOTO 5"
                            },
                            {
                                file: "static/imgs/exp/albuns/Cabaceiras/6.jpg.jpg",
                                legenda: "Cabaceiras FOTO 6"
                            },
                            {
                                file: "static/imgs/exp/albuns/Cabaceiras/7.jpg.jpg",
                                legenda: "Cabaceiras FOTO 7"
                            },
                            {
                                file: "static/imgs/exp/albuns/Cabaceiras/8.jpg.jpg",
                                legenda: "Cabaceiras FOTO 8"
                            },
                            {
                                file: "static/imgs/exp/albuns/Cabaceiras/9.jpg.jpg",
                                legenda: "Cabaceiras FOTO 9"
                            },
                        ]
                    },
                    {
                        id: 7,
                        legenda: "Jatoba",
                        indFoto: 0,
                        fotos: [
                            {
                                file: "static/imgs/exp/albuns/Jatoba/Jatoba 2.jpg",
                                legenda: "Jatoba FOTO 1"
                            },
                            {
                                file: "static/imgs/exp/albuns/Jatoba/Jatoba 3.jpg",
                                legenda: "Jatoba FOTO 2"
                            },
                            {
                                file: "static/imgs/exp/albuns/Jatoba/Jatoba 4.jpg",
                                legenda: "Jatoba FOTO 3"
                            },
                            {
                                file: "static/imgs/exp/albuns/Jatoba/Jatoba 5.jpg",
                                legenda: "Jatoba FOTO 4"
                            },
                            {
                                file: "static/imgs/exp/albuns/Jatoba/Jatoba.jpg",
                                legenda: "Jatoba FOTO 5"
                            },
                        ]
                    },
                    {
                        id: 8,
                        legenda: "Pico do Jabre",
                        indFoto: 0,
                        fotos: [
                            {
                                file: "static/imgs/exp/albuns/Pico do Jabre/36.jpg",
                                legenda: "Pico do Jabre FOTO 1"
                            },
                            {
                                file: "static/imgs/exp/albuns/Pico do Jabre/37.jpg",
                                legenda: "Pico do Jabre FOTO 2"
                            },
                            {
                                file: "static/imgs/exp/albuns/Pico do Jabre/38.jpg",
                                legenda: "Pico do Jabre FOTO 3"
                            },
                        ]
                    },
                ]
            }
        },
        components: {
            Slider: Slider
        },
        methods: {
            showGalery(show, alb, foto) {
                // se for mostrar a galeria deixa a tela Ajustar o viewport dinamicamente.
                if (show)
                    this.configureViewPort(show);

                if (foto !== undefined) {
                    let count = 0;
                    for (let j = 0; j < alb; j++) {
                        count += this.albuns[j].fotos.length
                    }
                    count += foto
                    this.fotoIndex = count
                }

                if (show)
                    $('.overgalery').fadeIn();
                else
                    $('.overgalery').fadeOut();
            }
        },
        created() {
            console.log(this.name + '::created!!');

            if (this.$route.params.stabs) {
                console.log('Usando estabs e cats passados por parametro!!');
                this.estabs_full = this.$route.params.stabs;
                this.cats_full = this.$route.params.categs;
                if (this.$route.params.idCat != null) {
                    this.idCat = this.$route.params.idCat;
                }
            }

            console.log(this.name + '::Terminei o created!!');
        },
        beforeMount() {
            console.log(this.name + '::beforeMount!!');

            console.log(this.name + '::Terminei o beforeMount!!');
        },
        mounted() {
            console.log(this.name + '::mounted::!!');

            console.log(this.name + '::Terminei o mounted!!');

            this.albunsFull = this.catAlbuns(this.albuns)
        },
    }
</script>


<style src="../assets/css/adv.css" scoped/>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .head0_2 {
        background-image: linear-gradient(var(--bg-blue-grad1), var(--bg-blue-grad2));
        /*background-color: var(--bg-header-color);*/
        height: var(--top-bar-heigth);
        width: 100vw;
        display:block;
        margin:auto;
        position:relative;
        font-size: 0;
    }
    .head1, .head2, .head3 {
        height: 100%;
        margin:auto;
        display: inline-block;
        position: relative;
    }
    .head1 {
        width: 15%;
        /*background-color: red;*/
        text-align: left;
    }
    .head2 {
        width: 68%;
        /*background-color: green;*/
        text-align: center;
    }
    .head3 {
        width: 15%;
        /*background-color: aqua;*/
        text-align: right;
    }

    .div_expedicao {
        margin: 2vh;
        background-color: white;
        background-size: cover;
        color: var(--bg-blue);
        font-size: 2vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-right: 2.5vw;
        padding-left: 2.5vw;
        padding-top: 2.5vw;
        padding-bottom: 0px;
        margin-bottom: 0px;
        /*background-color: #002b51;*/
    }

    .overgalery {
        position: fixed;
        width: 100vw;
        height: 100vh;
        background: rgba(10, 10, 10, 0.95);
        /*background-color: purple;*/
        /*z-index: 1;*/
        z-index: 1000;
        display: none;
        vertical-align: middle;
        top: 0;
    }
    .div_galery {
        /*vertical-align: middle;*/
        /*display: inline-block;*/
        /*background-color: red;*/
        display: flex;
        position: relative;
        flex-direction: column;
        /*align-items: center;*/
        justify-content: center;
        /*align-content: center;*/
        /*z-index: 1;*/
        /*width: 100%;*/
        height: 100%;
        /*padding-right: 2.5vw;*/
        /*padding-left: 2.5vw;*/
        /*margin: 0;*/
        /*padding: 0;*/
    }
    .div_fechar_over {
        /*background-color: green;*/
        position: absolute;
        height: 100%;
        min-width: 40px;
        vertical-align: center;
        top: 1vw;
        right: 1vw;
        display: flex;
        justify-content: center; /*right, left*/
        align-items: flex-start;
        /*background-color: blue;*/
    }

    .tx_border1, .tx_border2 {
        display: flex;
        font-family: 'Humanst521BT';
        font-weight: bold;
        justify-content: center;
    }

    .tx_border1 {
        color: white;
        font-size: 23vw;
        margin-top: -7vw;
        text-shadow: -1px 0 var(--bg-blue), 0 1px var(--bg-blue), 1px 0 var(--bg-blue), 0 -1px var(--bg-blue);
        /*background-color: pink;*/
    }

    .tx_border2 {
        color: var(--bg-blue);
        font-size: 18vw;
        margin-top: -24vw;
        /*background-color: red;*/
    }
</style>



// WEBPACK FOOTER //
// src/components/mExpedicaoAdvice.vue